import { IDeductionCalculator } from "../../types/calculatorTypes";
import { GET_DEDUCTION_CALCULATOR_DETAILS, GET_SESSION_FEES_CALCULATOR_DETAILS } from "../constants/calculatorConstant";

const init: IDeductionCalculator = {
  deductionCalculatorData: {},
  sessionFeeCalculatorData: {},
};

const deductionCalculatorReducer = (state: IDeductionCalculator = init, action: any): IDeductionCalculator => {
  switch (action.type) {
    case GET_DEDUCTION_CALCULATOR_DETAILS: {
      return {
        ...state,
        deductionCalculatorData: action.payload.data,
      };
    }
    case GET_SESSION_FEES_CALCULATOR_DETAILS: {
      return {
        ...state,
        sessionFeeCalculatorData: action.payload.data,
      };
    }
    default:
      return state;
  }
};
export default deductionCalculatorReducer;
